import React, { Component } from 'react';
import { FlatButton, List, ListItem, Popover } from 'material-ui';
import PropTypes from 'prop-types';

import FilterIcon from 'material-ui/svg-icons/content/filter-list';

const { array, bool, element, func, instanceOf, object, oneOfType, string } = PropTypes;

class FilterButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  handleClick = (event) => {
    this.props.onButtonClick();

    this.setState({
      anchorEl: event.currentTarget,
      isOpen: true,
    });
  };

  handleRequestClose = () => {
    this.props.onButtonClick();
    this.setState({ isOpen: false });
  };

  render() {
    const { children, items, onFilterChange, controlOpenStateFromProps } = this.props;
    const { isOpen } = controlOpenStateFromProps ? this.props : this.state;
    return (
      <div style={Object.assign({}, this.props.style)}>
        <FlatButton
          backgroundColor="rgba(0,0,0,0.04)"
          icon={<FilterIcon />}
          label={this.props.filterLabel || 'Filter'}
          labelPosition="after"
          onClick={this.handleClick}
        />
        <Popover
          open={isOpen}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={this.handleRequestClose}
        >
          { children ? children :
            <List>
              { items.map((item, i) =>
                <ListItem
                  key={i}
                  onClick={() => onFilterChange(i, item)}
                  primaryTogglesNestedList
                  primaryText={item.label}
                />
              )}
            </List>
          }
        </Popover>
      </div>
    );
  }
}

FilterButton.propTypes = {
  children: oneOfType([instanceOf(List), object]),
  filterLabel: oneOfType([element, string]),
  isOpen: bool,
  items: array,
  onButtonClick: func,
  onFilterChange: func,
  onItemSelect: func,
  style: object,
  controlOpenStateFromProps: bool,
};

export default FilterButton;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/filterButton.jsx